import { Type } from 'class-transformer';
import { ContactInfoEmailResultDto } from './contact-info-email-result-dto';
import { ContactInfoPhoneResultDto } from './contact-info-phone-result-dto';

export class ContactResultDto {
  id: number;
  name: string;
  contactType: string;
  isTenant: boolean;
  isLivingInProperty: boolean;
  isPublished: boolean;
  sequence: number;
  birthday: string;
  address: string;
  photoBase64Data: string;
  isPrimaryPhone: boolean;
  isPrimaryEmail: boolean;

  @Type(() => ContactInfoPhoneResultDto)
  phoneData: Array<ContactInfoPhoneResultDto>;

  @Type(() => ContactInfoPhoneResultDto)
  emailData: Array<ContactInfoEmailResultDto>;

  //Transient or Computed field
  isUnassigned: boolean;
  serialNumber: number;
  tabPanelTabs: { title: string; template: string };
  get photoUrl(): string {
    return !!this.photoBase64Data
      ? this.photoBase64Data
      : 'assets/images/avatar_question_round.png';
  }
}
